module.exports = __webpack_public_path__ + "img/main-bg.d094e91f.jpg";